import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Typography,
  Card,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Paper,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";

const API_URL = window.location.hostname === 'localhost' 
    ? "http://localhost:5400/admin" 
    : "https://crmb.apitrading.lk/admin";

export default function AdminDashboard() {
  const [exchangeRate, setExchangeRate] = useState(""); // Exchange Rate State
  const [open, setOpen] = useState(false);
  const [newRate, setNewRate] = useState("");
  const navigate = useNavigate();

  // ✅ Fetch Exchange Rate from Database on Load
  useEffect(() => {
    fetch(`${API_URL}/exchange-rate`)
      .then((response) => response.json())
      .then((data) => setExchangeRate(data.rate || "1.9938")) // Default value if no data
      .catch((error) => console.error("Error fetching exchange rate:", error));
  }, []);

  // ✅ Handle Popup Open & Close
  const handleClickOpen = () => {
    setNewRate(exchangeRate);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  // ✅ Handle Exchange Rate Update
  const handleSave = async () => {
    try {
      const response = await fetch(`${API_URL}/exchange-rate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ rate: newRate }),
      });

      if (response.ok) {
        setExchangeRate(newRate);
        setOpen(false);
      } else {
        console.error("Failed to update exchange rate.");
      }
    } catch (error) {
      console.error("Error updating exchange rate:", error);
    }
  };

  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />

      {/* 🔹 Currency Exchange Rate Notification (Below Header) */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 2, // Adds margin after header
        }}
      >
        <Paper
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "10px 15px",
            borderRadius: "5px",
            backgroundColor: "white",
            border: "2px solid red",
            cursor: "pointer",
            boxShadow: 2,
          }}
          onClick={handleClickOpen}
        >
          <Typography variant="body1">
            Currency Exchange Rate : (1 LKR = {exchangeRate})
          </Typography>
          <IconButton size="small" sx={{ ml: 1, color: "red" }}>
            <EditIcon />
          </IconButton>
        </Paper>
      </Box>

      {/* 🔹 Welcome Card */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "80vh",
        }}
      >
        <Card
          sx={{
            p: 4,
            mb: 4,
            textAlign: "center",
            backgroundColor: "rgba(94, 1, 1, 0.79)",
            color: "white",
            backdropFilter: "blur(10px)",
            boxShadow: "0 8px 32px 0 rgba(135, 64, 31, 0.84)",
            borderRadius: 2,
            border: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          <Typography variant="h4" gutterBottom>
            Welcome to Super Admin Dashboard
          </Typography>
          <Typography variant="body1">Manage system settings and users efficiently.</Typography>
        </Card>

        {/* 🔹 Buttons Grid */}
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={6} md={3}>
            <Button fullWidth variant="contained" sx={{ backgroundColor: "#F15A24" }} onClick={() => navigate("/carsSuperAdmin/createQuotation")}>
              Manage Users
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Button fullWidth variant="contained" sx={{ backgroundColor: "#007bff" }}>
              View Reports
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Button fullWidth variant="contained" sx={{ backgroundColor: "#28a745" }}>
              Settings
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Button fullWidth variant="contained" sx={{ backgroundColor: "#dc3545" }}>
              Logout
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/* 🔹 Exchange Rate Edit Popup */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit Exchange Rate</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Exchange Rate"
            type="number"
            fullWidth
            variant="outlined"
            value={newRate}
            onChange={(e) => setNewRate(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
